const liveTvRouteBase = import.meta.env.VITE_APP_TARGET === 'live-tv' ? '' : 'live-tv';

function withLiveTvBase(path: string) {
  return [liveTvRouteBase, path].filter(Boolean).join('/');
}

export const liveTvRoutePaths = {
  INDEX: withLiveTvBase(''),
  CHANNEL: withLiveTvBase('channel/:channelId'),
} as const;

export function getLiveTvChannelPath(channelId: string) {
  return withLiveTvBase(`channel/${channelId}`);
}
